import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/bans';

export default {
  getAllBans(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/prison${queryString}`);
  },
  createBan(ban) {
    return axios.post(`${base}/create`, ban);
  },
  deleteBan(id) {
    return axios.delete(`${base}/delete/${id}`);
  },
  updateBan(id, dto) {
    return axios.put(`${base}/update/${id}`, dto);
  },
};
